import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import useContractTypeValidator from './useContractTypeValidator';
import { useAuth } from '../contexts/auth';
import { getProjectId } from '../lib/common';
import NoDataView from '../pages/NoDataView';

const WithCsportalAuth = (Component, currentComponentType = 'paid') => {
  const AuthRoute = (props) => {
    const [authState] = useAuth();
    const { selectedBusiness } = authState;
    const queryParams = new URLSearchParams(window.location.search);
    const queryDocId = queryParams.get('docid');
    const [isProperContractType, validator, contractTypeVal] = useContractTypeValidator(currentComponentType);
    const projectId = getProjectId();
    const params = useParams();

    const ignoreFaqKeys = ['Edit-my-Business', 'JD-Pay'];

    if (
      projectId !== 'csportal' ||
      !queryDocId ||
      (window.location.pathname.includes('faq') && ignoreFaqKeys.includes(params.key))
    ) {
      return <Component {...props} />;
    }
    React.useEffect(() => {
      if (projectId === 'csportal' && queryDocId) {
        validator();
      }
    }, [selectedBusiness, queryDocId]);
    if (isProperContractType) {
      return <Component {...props} />;
    }
    if (projectId === 'csportal' && queryDocId && authState?.sidResponse && contractTypeVal === 'free') {
      return <NoDataView pageName="" />;
    }
    return null;
  };

  return AuthRoute;
};

WithCsportalAuth.propTypes = {
  Component: PropTypes.node,
  currentComponentType: PropTypes.string,
};

WithCsportalAuth.defaultProps = {
  currentComponentType: 'paid',
};

export default WithCsportalAuth;
